<span class="span-margin">{{viewFormatter(value)}}</span>
